import { apiCall } from "./authServieces";

export const manageUser = async (showSnackBar, page = 1, limit = 10) => {
  try {
    const res = await apiCall({
      endpoint: `api/pg/get-dealer-list-wallet-recharge`,
      method: "GET",
    });
    if (res?.success) {
      return res;
    }
  } catch (err) {
    showSnackBar({
      open: true,
      severity: false,
      message: err?.response?.data?.message || "An error occurred",
    });
    return (
      err?.response?.data || { success: false, message: "An error occurred" }
    );
  }
};

export const rechargeWallet = async (payload) => {
  const response = await apiCall({
    endpoint: "api/pg/dealer-wallet-recharge",
    method: "POST",
    payload: payload,
  });
  return response;
}


export const getDashboardDealerCSV = async () => {
  try {
    const res = await apiCall({
      endpoint: "api/reports/get-dashboard-dealer-csv",
      method: "GET",
      config: { responseType: "blob" },
    });

    const url = window.URL.createObjectURL(new Blob([res.data]));

    // Get filename from headers if present
    const contentDisposition = res.headers["content-disposition"];
    let fileName = "dashboard_dealer_export.csv";
    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?(.+)"?/);
      if (match && match[1]) fileName = match[1];
    }

    // Trigger download
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();

    // Cleanup
    window.URL.revokeObjectURL(url);

    return { success: true };
  } catch (err) {
    return (
      err?.response?.data || { success: false, message: "An error occurred" }
    );
  }
};

